// Auto-generated by @gyoll/builder - DO NOT EDIT
export const routes = [
  {
    "path": "/",
    "component": () => import("./routes/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx")
    ],
    "guard": () => import("./routes/guard.js")
  },
  {
    "path": "/*",
    "component": () => import("./routes/[...slorgIds]/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx")
    ],
    "guard": () => import("./routes/guard.js"),
    "catchAllParam": "slorgIds"
  },
  {
    "path": "/agenda",
    "component": () => import("./routes/agenda/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx")
    ],
    "guard": () => import("./routes/guard.js")
  },
  {
    "path": "/directories",
    "component": () => import("./routes/directories/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx")
    ],
    "guard": () => import("./routes/directories/guard.js")
  },
  {
    "path": "/onboarding",
    "component": () => import("./routes/onboarding/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx")
    ],
    "guard": () => import("./routes/guard.js")
  },
  {
    "path": "/settings",
    "component": () => import("./routes/settings/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx"),
      () => import("./routes/settings/layout.jsx")
    ],
    "guard": () => import("./routes/guard.js")
  },
  {
    "path": "/settings/account",
    "component": () => import("./routes/settings/account/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx"),
      () => import("./routes/settings/layout.jsx")
    ],
    "guard": () => import("./routes/guard.js")
  },
  {
    "path": "/settings/config",
    "component": () => import("./routes/settings/config/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx"),
      () => import("./routes/settings/layout.jsx")
    ],
    "guard": () => import("./routes/guard.js")
  },
  {
    "path": "/settings/data",
    "component": () => import("./routes/settings/data/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx"),
      () => import("./routes/settings/layout.jsx")
    ],
    "guard": () => import("./routes/guard.js")
  },
  {
    "path": "/settings/notifications",
    "component": () => import("./routes/settings/notifications/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx"),
      () => import("./routes/settings/layout.jsx")
    ],
    "guard": () => import("./routes/guard.js")
  },
  {
    "path": "/settings/quickadd",
    "component": () => import("./routes/settings/quickadd/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx"),
      () => import("./routes/settings/layout.jsx")
    ],
    "guard": () => import("./routes/guard.js")
  },
  {
    "path": "/settings/tags",
    "component": () => import("./routes/settings/tags/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx"),
      () => import("./routes/settings/layout.jsx")
    ],
    "guard": () => import("./routes/guard.js")
  },
  {
    "path": "/settings/templates",
    "component": () => import("./routes/settings/templates/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx"),
      () => import("./routes/settings/layout.jsx")
    ],
    "guard": () => import("./routes/guard.js")
  },
  {
    "path": "/sign/in",
    "component": () => import("./routes/sign/in/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx"),
      () => import("./routes/sign/layout.jsx")
    ],
    "guard": () => import("./routes/sign/guard.js")
  },
  {
    "path": "/sign/up",
    "component": () => import("./routes/sign/up/index.jsx"),
    "layouts": [
      () => import("./routes/layout.jsx"),
      () => import("./routes/sign/layout.jsx")
    ],
    "guard": () => import("./routes/sign/guard.js")
  }
];
